var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.8 0H3.2A3.2 3.2 0 000 3.2v38.6A3.2 3.2 0 003.2 45h38.6a3.2 3.2 0 003.2-3.2V3.2A3.2 3.2 0 0041.8 0zM13.6 38.6H6.9V17h6.7v21.5zm-3.3-24.4a3.9 3.9 0 113.8-3.9 3.9 3.9 0 01-3.8 3.9zm28.3 24.4h-6.7V28c0-2.5 0-5.7-3.4-5.7-3.5 0-4 2.7-4 5.5v10.7h-6.7V17h6.4v3a7 7 0 016.4-3.5c6.8 0 8 4.4 8 10.2z","fill":"#fff"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
